import type { FaireProductEntity } from "../../entity_types/product";

export const p_tn8wse74gr: FaireProductEntity = {
  token: "p_tn8wse74gr",
  type: "product",
  name: "CALABRIAN CHILI HOT SAUCE",
  brandToken: "b_3tsns4s75m",
  brandName: "MOTO",
  imageUrl:
    "https://cdn.faire.com/fastly/0171b26cc0415de0b4866c5f3ca159816830def31f152390aa965f1ca49ad305.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fac8e8e07c7f41e6c9537a844b9f8606b5680329abdb7d01ed6ab053a92393da.jpeg",
    "https://cdn.faire.com/fastly/a7e7c1a43d093b15924e5762ba1cfe71d6d3ba6bbb71bcacbaec9e0ee656abc7.jpeg",
  ],
  priceDollars: 6,
  description:
    "Iconic Italian heat craft-blended with acid, smoke, salt, and sweet in an easy no-mess squeeze bottle. Fire up pizza, pasta, panini, protein, and veg.\n\nSize: 8 FL OZ (237 ML)\nHeat: Medium\nCraft-blended in Northern California.\n\nIngredients:\nCrushed Calabrian Chili Peppers (Chili Peppers, Sunflower Oil, Extra Virgin Olive Oil, Salt, Vinegar, Basil), Distilled White Vinegar, Sunflower Oil, Honey, Mediterranean Sea Salt, Paprika, Granulated Garlic, White Pepper, Xanthan Gum\n\nCalabrian chiles are medium-hot red peppers from Calabria, a region in southern Italy. Known for their bright, fruity flavor with sweet, smoky, and tangy notes, they range in shape and color, from green to yellow to red when ripe. These chiles are similar in heat to cayenne peppers and come in both sweet and spicy varieties, though most imported products tend to be hot. Their balanced heat and vibrant taste make them a popular choice in Calabrian cuisine.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:35.195Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
